import { render, staticRenderFns } from "./hover.vue?vue&type=template&id=3fea63d3&scoped=true&"
import script from "./hover.vue?vue&type=script&lang=js&"
export * from "./hover.vue?vue&type=script&lang=js&"
import style0 from "./hover.vue?vue&type=style&index=0&id=3fea63d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fea63d3",
  null
  
)

export default component.exports